import { FareRuleMapKeyRes } from "@models/booking.model";
import { BookingFareRuleRes } from "@models/flight.model";
import { createAction, props } from "@ngrx/store";

export const setFlightFareRuleMapKey = createAction(
    '[Flight] set flight fare rule map key',
    props<{ fareRules: FareRuleMapKeyRes[] }>()
);

export const setFlightFareRule = createAction(
    '[Flight] set flight detail',
    props<{ fareRule: { [key: string]: BookingFareRuleRes[] } }>()
);

